import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Programs = styled.div`
  margin-top: 6px;
`;

const ProgramItem = styled.span`
  display: inline-block;
  color: #888888;
  &:not(:last-child):after {
    content: ',';
    color: #888888;
    margin-right: 3px;
  }
  &.matched {
    font-weight: 600;
  }
  &.matched.selected {
    color: #1675e0;
  }
  &.ineligible:not(.selected) {
    color: #f44336;
    text-decoration: line-through;
  }
`;

const programClass = (isMatched, isSelected, isGuestEligible) => {
  const matchedClass = isMatched ? 'matched' : '';
  const selectedClass = isSelected ? 'selected' : '';
  const ineligibleClass = !isGuestEligible ? 'ineligible' : '';

  return `${matchedClass} ${selectedClass} ${ineligibleClass}`;
};

const EventPrograms = ({ programs, isSelected, ...props }) => (
  <Programs {...props}>
    {programs.map(({ label, isGuestEligible, isSelected: isMatched }) => (
      <ProgramItem
        key={label}
        className={programClass(isMatched, isSelected, isGuestEligible)}
      >
        {label}
      </ProgramItem>
    ))}
  </Programs>
);

EventPrograms.propTypes = {
  programs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      isMatch: PropTypes.bool.isRequired,
      isGuestEligible: PropTypes.bool.isRequired,
      isSelected: PropTypes.bool.isRequired
    })
  ).isRequired,
  isSelected: PropTypes.bool.isRequired
};
export default EventPrograms;
